import { CommanderThunkAction } from '@mews-commander/types';
import { getCurrentEnterpriseId } from '@mews-commander/core';

export const logBillingAction =
    (message: $TSFixMe, context = {}): CommanderThunkAction =>
    (dispatch, getState, { loggerService }) => {
        const enterpriseId = getCurrentEnterpriseId();
        loggerService.log('new-billing', message, {
            enterpriseId,
            ...context,
        });
    };
